import { useEffect, useState } from 'react';

// Tailwind's `md` breakpoint (min-width: 768px). Project pages show the top
// toolbar at/above it and the fixed mobile bottom bar below it.
const DESKTOP_QUERY = '(min-width: 768px)';

const matchesDesktop = (): boolean =>
  typeof window !== 'undefined' && 'matchMedia' in window
    ? window.matchMedia(DESKTOP_QUERY).matches
    : true;

/**
 * `true` when the viewport is at Tailwind's `md` breakpoint or wider.
 *
 * Lets a page mount the desktop toolbar OR the mobile bottom bar (never both),
 * so their popovers and outside-click listeners aren't duplicated.
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState<boolean>(matchesDesktop);

  useEffect(() => {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return;
    const mql = window.matchMedia(DESKTOP_QUERY);
    const onChange = (event: MediaQueryListEvent) =>
      setIsDesktop(event.matches);
    mql.addEventListener('change', onChange);
    setIsDesktop(mql.matches); // sync in case it changed before the listener attached
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
}
